import { groupModel } from 'APP/model/model';

export async function removeParticipants(
  groupId: string,
  userIds: string[]
): Promise<{ error: string | null }> {
  try {
    await groupModel.removeGroupParticipants({ groupId, userIds });

    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
}
